module.exports = __webpack_public_path__ + "img/js6.4287b1fc.jpg";